// Units are in pixels
export const COMMENT_HEADER_TOP_PADDING = 10;
export const COMMENT_HEADER_BOTTOM_PADDING = 10;
export const COMMENT_HEADER_CONTENT_HEIGHT = 40;
export const COMMENT_HEADER_PADDING_BOX_HEIGHT =
    COMMENT_HEADER_TOP_PADDING + COMMENT_HEADER_CONTENT_HEIGHT + COMMENT_HEADER_BOTTOM_PADDING;
